import dhtmlXTreeObject from './dhtmlXTreeObject';
import {dhx4} from '../../global/dhx4OrDhx';
import dhtmlx from '../../global/dhtmlx';
import {globalObj} from '../dXGridObject/dxGridComClass';
import dhx_li2trees from './dhx_li2trees';
import {getCookie} from './CookieUtils';
import jsonPointer from './jsonPointer';


dhtmlXTreeObject.prototype.loadJSArrayFile = function (a, c) {
    if (window.console && window.console.info) {
        window.console.info("loadJSArrayFile was deprecated", "http://docs.dhtmlx.com/migration__index.html#migrationfrom43to44");
    }
    return this._loadJSArrayFile(a, c);
};
dhtmlXTreeObject.prototype._loadJSArrayFile = function (file, callback) {
    if (!this.parsCount) {
        this.callEvent("onXLS", [this, this._ld_id]);
    }
    this._ld_id = null;
    this.xmlstate = 1;
    var that = this;
    this.XMLLoader = function (xml, callback) {
        eval("var z=" + xml.responseText);

        this._loadJSArray(z);
        if (callback) {
            callback.call(this, xml);
        }
    };
    dhx4.ajax.get(file, function (obj) {
        that.XMLLoader(obj.xmlDoc, callback);
    });
};
dhtmlXTreeObject.prototype.loadCSV = function (a, c) {
    if (window.console && window.console.info) {
        window.console.info("loadCSV was deprecated", "http://docs.dhtmlx.com/migration__index.html#migrationfrom43to44");
    }
    return this._loadCSV(a, c);
};
dhtmlXTreeObject.prototype._loadCSV = function (a, e) {
    if (!this.parsCount) {
        this.callEvent("onXLS", [this, this._ld_id]);
    }
    this._ld_id = null;
    this.xmlstate = 1;
    var c = this;
    this.XMLLoader = function (g, h) {
        this._loadCSVString(g.responseText);
        if (h) {
            h.call(this, g);
        }
    };
    dhx4.ajax.get(a, function (g) {
        c.XMLLoader(g.xmlDoc, e);
    });
};
dhtmlXTreeObject.prototype.loadJSArray = function (a, c) {
    if (window.console && window.console.info) {
        window.console.info("loadJSArray was deprecated", "http://docs.dhtmlx.com/migration__index.html#migrationfrom43to44");
    }
    return this._loadJSArray(a, c);
};
dhtmlXTreeObject.prototype._loadJSArray = function (a, g) {
    var l = [];
    for (var c = 0; c < a.length; c++) {
        if (!l[a[c][1]]) {
            l[a[c][1]] = [];
        }
        l[a[c][1]].push({ id: a[c][0], text: a[c][2] });
    }
    var h = { id: this.rootId };
    var e = function (o, n) {
        if (l[o.id]) {
            o.item = l[o.id];
            for (var m = 0; m < o.item.length; m++) {
                n(o.item[m], n);
            }
        }
    };
    e(h, e);
    this._loadJSONObject(h, g);
};
dhtmlXTreeObject.prototype.loadCSVString = function (a, c) {
    if (window.console && window.console.info) {
        window.console.info("loadCSVString was deprecated", "http://docs.dhtmlx.com/migration__index.html#migrationfrom43to44");
    }
    return this._loadCSVString(a, c);
};
dhtmlXTreeObject.prototype._loadCSVString = function (a, l) {
    var n = [];
    var c = a.split("\n");
    for (var g = 0; g < c.length; g++) {
        var e = c[g].split(",");
        if (!n[e[1]]) {
            n[e[1]] = [];
        }
        n[e[1]].push({ id: e[0], text: e[2] });
    }
    var m = { id: this.rootId };
    var h = function (s, r) {
        if (n[s.id]) {
            s.item = n[s.id];
            for (var o = 0; o < s.item.length; o++) {
                r(s.item[o], r);
            }
        }
    };
    h(m, h);
    this._loadJSONObject(m, l);
};
dhtmlXTreeObject.prototype.loadJSONObject = function (a, c) {
    if (window.console && window.console.info) {
        window.console.info("loadJSONObject was deprecated", "http://docs.dhtmlx.com/migration__index.html#migrationfrom43to44");
    }
    return this._loadJSONObject(a, c);
};
dhtmlXTreeObject.prototype._loadJSONObject = function (a, c) {
    if (!this.parsCount) {
        this.callEvent("onXLS", [this, null]);
    }
    this.xmlstate = 1;
    var e = new jsonPointer(a);
    this._parse(e);
    this._p = e;
    if (c) {
        c();
    }
};
dhtmlXTreeObject.prototype.loadJSON = function (a, c) {
    if (window.console && window.console.info) {
        window.console.info("loadJSON was deprecated", "http://docs.dhtmlx.com/migration__index.html#migrationfrom43to44");
    }
    return this._loadJSON(a, c);
};
dhtmlXTreeObject.prototype._loadJSON = function (file, callback) {
    if (!this.parsCount) {
        this.callEvent("onXLS", [this, this._ld_id]);
    }
    this._ld_id = null;
    this.xmlstate = 1;
    var that = this;
    this.XMLLoader = function (xml, callback) {
        try {
            eval("var t=" + xml.responseText);
        }
        catch (e) {
            dhx4.callEvent("onLoadXMLerror", ["Incorrect JSON", xml, this]);
            return;
        }

        var p = new jsonPointer(t);
        this._parse(p);
        this._p = p;
        if (callback) {
            callback.call(this, xml);
        }
    };
    dhx4.ajax.get(file, function (obj) {
        that.XMLLoader(obj.xmlDoc, callback);
    });
};
dhtmlXTreeObject.prototype.serializeTreeToJSON = function () {
    var a = ['{"id":"' + this.rootId + '", "item":['];
    var e = [];
    for (var c = 0; c < this.htmlNode.childsCount; c++) {
        e.push(this._serializeItemJSON(this.htmlNode.childNodes[c]));
    }
    a.push(e.join(","));
    a.push("]}");
    return a.join("");
};
dhtmlXTreeObject.prototype._serializeItemJSON = function (m) {
    var a = [];
    if (m.unParsed) {
        return m.unParsed.text();
    }
    if (this._selected.length) {
        var e = this._selected[0].id;
    }
    else {
        e = "";
    }
    var l = m.span.innerHTML;
    l = l.replace(/\"/g, '\\"', l);
    if (!this._xfullXML) {
        a.push('{ "id":"' +
            m.id +
            '", ' +
            (this._getOpenState(m) == 1 ? ' "open":"1", ' : "") +
            (e == m.id ? ' "select":"1",' : "") +
            ' "text":"' +
            l +
            '"' +
            (this.XMLsource && m.XMLload == 0 ? ', "child":"1" ' : ""));
    }
    else {
        a.push('{ "id":"' +
            m.id +
            '", ' +
            (this._getOpenState(m) == 1 ? ' "open":"1", ' : "") +
            (e == m.id ? ' "select":"1",' : "") +
            ' "text":"' +
            l +
            '", "im0":"' +
            m.images[0] +
            '", "im1":"' +
            m.images[1] +
            '", "im2":"' +
            m.images[2] +
            '" ' +
            (m.acolor ? ', "aCol":"' + m.acolor + '" ' : "") +
            (m.scolor ? ', "sCol":"' + m.scolor + '" ' : "") +
            (m.checkstate == 1
                ? ', "checked":"1" '
                : m.checkstate == 2
                    ? ', "checked":"-1"'
                    : "") +
            (m.closeable ? ', "closeable":"1" ' : "") +
            (this.XMLsource && m.XMLload == 0 ? ', "child":"1" ' : ""));
    }
    var g = null;
    if (this._xuserData && m._userdatalist) {
        a.push(', "userdata":[');
        var h = m._userdatalist.split(",");
        g = [];
        for (var c = 0; c < h.length; c++) {
            g.push('{ "name":"' +
                h[c] +
                '" , "content":"' +
                m.userData["t_" + h[c]] +
                '" }');
        }
        a.push(g.join(","));
        a.push("]");
    }
    if (m.childsCount) {
        a.push(', "item":[');
        g = [];
        for (var c_1 = 0; c_1 < m.childsCount; c_1++) {
            g.push(this._serializeItemJSON(m.childNodes[c_1]));
        }
        a.push(g.join(","));
        a.push("]\n");
    }
    a.push("}\n");
    return a.join("");
};
function dhtmlXTreeFromHTML(obj) {
    if (typeof obj != "object") {
        obj = document.getElementById(obj);
    }
    var n = obj;
    var id = n.id;
    var cont = "";
    for (var j = 0; j < obj.childNodes.length; j++) {
        if (obj.childNodes[j].nodeType == "1") {
            if (obj.childNodes[j].tagName == "XMP") {
                var cHead = obj.childNodes[j];
                for (var m = 0; m < cHead.childNodes.length; m++) {
                    cont += cHead.childNodes[m].data;
                }
            }
            else {
                if (obj.childNodes[j].tagName.toLowerCase() == "ul") {
                    cont = dhx_li2trees(obj.childNodes[j], new Array(), 0);
                }
            }
            break;
        }
    }
    obj.innerHTML = "";
    var t = new dhtmlXTreeObject(obj, "100%", "100%", 0);
    var z_all = new Array();
    for (var b in t) {

        z_all[b.toLowerCase()] = b;
    }
    var atr = obj.attributes;
    for (var a = 0; a < atr.length; a++) {
        if (atr[a].name.indexOf("set") == 0 || atr[a].name.indexOf("enable") == 0) {
            var an = atr[a].name;
            if (!t[an]) {
                an = z_all[atr[a].name];
            }
            t[an].apply(t, atr[a].value.split(","));
        }
    }
    if (typeof cont == "object") {
        t.XMLloadingWarning = 1;
        for (var i = 0; i < cont.length; i++) {
            var nEl = t.insertNewItem(cont[i][0], cont[i][3], cont[i][1]);
            if (cont[i][2]) {
                t._setCheck(nEl, cont[i][2]);
            }
        }
        t.XMLloadingWarning = 0;
        t.lastLoadedXMLId = 0;
        t._redrawFrom(t);
    }
    else {
        t.parse("<tree id='0'>" + cont + "</tree>");
    }
    window[id] = t;
    var oninit = obj.getAttribute("oninit");
    if (oninit) {
        eval(oninit);
    }
    return t;
}
function dhx_init_trees() {
    var c = document.getElementsByTagName("div");
    for (var a = 0; a < c.length; a++) {
        if (c[a].className == "dhtmlxTree") {
            dhtmlXTreeFromHTML(c[a]);
        }
    }
}
if (window.addEventListener) {
    window.addEventListener("load", dhx_init_trees, false);
}
else {
    if (window.attachEvent) {
        window.attachEvent("onload", dhx_init_trees);
    }
}
dhtmlXTreeObject.prototype.parserExtension = {
    _parseExtension: function (g, c) {
        this._idpull[c.id]._attrs = c;
    }
};
dhtmlXTreeObject.prototype.getAttribute = function (e, a) {
    this._globalIdStorageFind(e);
    var c = this._idpull[e]._attrs;
    return c ? c[a] : window.undefined;
};
dhtmlXTreeObject.prototype.setAttribute = function (g, a, e) {
    this._globalIdStorageFind(g);
    var c = this._idpull[g]._attrs || {};
    c[a] = e;
    this._idpull[g]._attrs = c;
};
dhtmlXTreeObject.prototype.enableKeyboardNavigation = function (e) {
    this._enblkbrd = dhx4.s2b(e);
    if (this._enblkbrd) {
        var c = null;
        if (window._isFF) {
            c = window.getComputedStyle(this.parentObject, null)["position"];
            if (c != "absolute" && c != "relative") {
                this.parentObject.style.position = "relative";
            }
        }
        this._navKeys = [
            ["up", 38],
            ["down", 40],
            ["open", 39],
            ["close", 37],
            ["call", 13],
            ["edit", 113]
        ];
        var a = this;
        c = document.createElement("INPUT");
        c.className = "a_dhx_hidden_input";
        c.autocomplete = "off";
        if (window._KHTMLrv) {
            c.style.color = "white";
        }
        this.parentObject.appendChild(c);
        this.parentObject[window._isOpera ? "onkeypress" : "onkeydown"] = function (g) {
            if (a.callEvent("onKeyPress", [
                (g || window.event).keyCode,
                g || window.event
            ])) {
                return a._onKeyDown(g || window.event);
            }
        };
        this.parentObject.onclick = function () {
            if (window._isFF || window._isIE) {
                c.select();
            }
            if (window._KHTMLrv || window._isOpera) {
                c.focus();
            }
        };
    }
    else {
        this.parentObject.onkeydown = null;
    }
};
dhtmlXTreeObject.prototype._onKeyDown = function (g) {
    if (globalObj.globalActiveDHTMLGridObject &&
        globalObj.globalActiveDHTMLGridObject.isActive) {
        return true;
    }

    for (var c = 0; c < this._navKeys.length; c++) {
        if (this._navKeys[c][1] == g.keyCode) {
            this["_onkey_" + this._navKeys[c][0]].apply(this, [
                this.getSelectedItemId()
            ]);
            if (g.preventDefault) {
                g.preventDefault();
            }
            (g || event).cancelBubble = true;
            return false;
        }
    }
    if (this._textSearch) {
        return this._searchItemByKey(g);
    }
    return true;
};
dhtmlXTreeObject.prototype._onkey_up = function (e) {
    var a = this._globalIdStorageFind(e);
    if (!a) {
        return;
    }
    var c = this._getPrevVisibleNode(a);
    if (c.id == this.rootId) {
        return;
    }
    this.focusItem(c.id);
    this.selectItem(c.id, false);
};
dhtmlXTreeObject.prototype._onkey_down = function (e) {
    var a = this._globalIdStorageFind(e);
    if (!a) {
        return;
    }
    var c = this._getNextVisibleNode(a);
    if (c.id == this.rootId) {
        return;
    }
    this.focusItem(c.id);
    this.selectItem(c.id, false);
};
dhtmlXTreeObject.prototype._onkey_open = function (a) {
    this.openItem(a);
};
dhtmlXTreeObject.prototype._onkey_close = function (a) {
    this.closeItem(a);
};
dhtmlXTreeObject.prototype._onkey_call = function (a) {
    if (this.stopEdit) {
        this.stopEdit();
        this.parentObject.lastChild.focus();
        this.parentObject.lastChild.focus();
        this.selectItem(a, true);
    }
    else {
        this.selectItem(this.getSelectedItemId(), true);
    }
};
dhtmlXTreeObject.prototype._onkey_edit = function (a) {
    if (this.editItem) {
        this.editItem(a);
    }
};
dhtmlXTreeObject.prototype._getNextVisibleNode = function (a, c) {
    if (!c && this._getOpenState(a) > 0) {
        return a.childNodes[0];
    }
    if (a.tr && a.tr.nextSibling && a.tr.nextSibling.nodem) {
        return a.tr.nextSibling.nodem;
    }
    if (a.parentObject) {
        return this._getNextVisibleNode(a.parentObject, 1);
    }
    return a;
};
dhtmlXTreeObject.prototype._getPrevVisibleNode = function (a) {
    if (a.tr && a.tr.previousSibling && a.tr.previousSibling.nodem) {
        return this._lastVisibleChild(a.tr.previousSibling.nodem);
    }
    if (a.parentObject) {
        return a.parentObject;
    }
    else {
        return a;
    }
};
dhtmlXTreeObject.prototype._lastVisibleChild = function (a) {
    if (this._getOpenState(a) > 0) {
        return this._lastVisibleChild(a.childNodes[a.childsCount - 1]);
    }
    else {
        return a;
    }
};
dhtmlXTreeObject.prototype._searchItemByKey = function (c) {
    if (c.keyCode == 8) {
        this._textSearchString = "";
        return true;
    }
    var a = String.fromCharCode(c.keyCode).toUpperCase();
    if (a.match(/[A-Z,a-z,0-9\ ]/)) {
        this._textSearchString += a;
        this._textSearchInProgress = true;
        if (!(this.getSelectedItemText() || "").match(RegExp("^" + this._textSearchString, "i"))) {
            this.findItem(this._textSearchString, 0);
        }
        this._textSearchInProgress = false;
        if (c.preventDefault) {
            c.preventDefault();
        }
        (c || event).cancelBubble = true;
        return false;
    }
    return true;
};
dhtmlXTreeObject.prototype.assignKeys = function (a) {
    this._navKeys = a;
};
dhtmlXTreeObject.prototype.enableKeySearch = function (c) {
    this._textSearch = dhx4.s2b(c);
    if (!this._textSearch) {
        return;
    }
    this._textSearchString = "";
    var a = this;
    this._markItem2 = this._markItem;
    this._markItem = function (e) {
        if (!a._textSearchInProgress) {
            a._textSearchString = "";
        }
        a._markItem2(e);
    };
};
dhtmlXTreeObject.prototype.enableLoadingItem = function (a) {
    this.attachEvent("onXLS", this._showFakeItem);
    this.attachEvent("onXLE", this._hideFakeItem);
    this._tfi_text = a || "Loading...";
};
dhtmlXTreeObject.prototype._showFakeItem = function (a, e) {
    if (e === null || this._globalIdStorageFind("fake_load_xml_" + e)) {
        return;
    }
    var c = this.XMLsource;
    this.XMLsource = null;
    this.insertNewItem(e, "fake_load_xml_" + e, this._tfi_text);
    this.XMLsource = c;
};
dhtmlXTreeObject.prototype._hideFakeItem = function (a, c) {
    if (c === null) {
        return;
    }
    this.deleteItem("fake_load_xml_" + c);
};
dhtmlXTreeObject.prototype.isLocked = function (a) {
    if (!this._locker) {
        this._init_lock();
    }
    return this._locker[a] == true;
};
dhtmlXTreeObject.prototype._lockItem = function (a, h, c) {
    if (!this._locker) {
        this._init_lock();
    }
    var g = null, e = null;
    if (h) {
        if (this._locker[a.id] == true) {
            return;
        }
        this._locker[a.id] = true;
        a.bIm0 = a.images[0];
        a.bIm1 = a.images[1];
        a.bIm2 = a.images[2];
        a.images[0] = this.lico0;
        a.images[1] = this.lico1;
        a.images[2] = this.lico2;
        g = a.span.parentNode;
        e = g.previousSibling;
        this.dragger.removeDraggableItem(g);
        this.dragger.removeDraggableItem(e);
    }
    else {
        if (this._locker[a.id] != true) {
            return;
        }
        this._locker[a.id] = false;
        a.images[0] = a.bIm0;
        a.images[1] = a.bIm1;
        a.images[2] = a.bIm2;
        g = a.span.parentNode;
        e = g.previousSibling;
        this.dragger.addDraggableItem(g, this);
        this.dragger.addDraggableItem(e, this);
    }
    if (!c) {
        this._correctPlus(a);
    }
};
dhtmlXTreeObject.prototype.lockItem = function (e, c) {
    if (!this._locker) {
        this._init_lock();
    }
    this._lockOn = false;
    var a = this._globalIdStorageFind(e);
    this._lockOn = true;
    this._lockItem(a, dhx4.s2b(c));
};
dhtmlXTreeObject.prototype.setLockedIcons = function (e, c, a) {
    if (!this._locker) {
        this._init_lock();
    }
    this.lico0 = e;
    this.lico1 = c;
    this.lico2 = a;
};
dhtmlXTreeObject.prototype._init_lock = function () {
    this._locker = new Array();
    this._locker_count = "0";
    this._lockOn = true;
    this._globalIdStorageFindA = this._globalIdStorageFind;
    this._globalIdStorageFind = this._lockIdFind;
    if (this._serializeItem) {
        this._serializeItemA = this._serializeItem;
        this._serializeItem = this._serializeLockItem;
        this._serializeTreeA = this.serializeTree;
        this.serializeTree = this._serializeLockTree;
    }
    this.setLockedIcons(this.imageArray[0], this.imageArray[1], this.imageArray[2]);
};
dhtmlXTreeObject.prototype._lockIdFind = function (e, a, c) {
    if (!this.skipLock) {
        if (!c && this._lockOn == true && this._locker[e] == true) {
            return null;
        }
    }
    return this._globalIdStorageFindA(e, a, c);
};
dhtmlXTreeObject.prototype._serializeLockItem = function (a) {
    if (this._locker[a.id] == true) {
        return "";
    }
    return this._serializeItemA(a);
};
dhtmlXTreeObject.prototype._serializeLockTree = function () {
    var a = this._serializeTreeA();
    return a.replace(/<item[^>]+locked\=\"1\"[^>]+\/>/g, "");
};
dhtmlXTreeObject.prototype._moveNodeToA = dhtmlXTreeObject.prototype._moveNodeTo;
dhtmlXTreeObject.prototype._moveNodeTo = function (a, e, c) {
    if (e.treeNod.isLocked && e.treeNod.isLocked(e.id)) {
        return false;
    }
    return this._moveNodeToA(a, e, c);
};
dhtmlXTreeObject.prototype.lockTree = function (a) {
    if (dhx4.s2b(a)) {
        this._initTreeLocker();
    }
    else {
        if (this._TreeLocker) {
            this._TreeLocker.parentNode.removeChild(this._TreeLocker);
            this._TreeLocker = null;
        }
    }
};
dhtmlXTreeObject.prototype._initTreeLocker = function () {
    if (this._TreeLocker) {
        return;
    }
    this.parentObject.style.overflow = "hidden";
    if (this.parentObject.style.position != "absolute") {
        this.parentObject.style.position = "relative";
    }
    var c = document.createElement("div");
    c.style.position = "absolute";
    c.style.left = "0px";
    c.style.top = "0px";
    c.className = "dhx_tree_opacity";
    c.style.width = this.allTree.offsetWidth + "px";
    c.style.backgroundColor = "#FFFFFF";
    c.style.height = this.allTree.offsetHeight + "px";
    this._TreeLocker = c;
    this.parentObject.appendChild(this._TreeLocker);
};
dhtmlXTreeObject.prototype.enableRTL = function (c) {
    var a = dhx4.s2b(c);
    if ((a && !this.rtlMode) || (!a && this.rtlMode)) {
        this.rtlMode = a;
        this._switchToRTL(this.rtlMode);
    }
};
dhtmlXTreeObject.prototype._switchToRTL = function (a) {
    if (a) {
        this.allTree.className = this._ltr_line = this.lineArray;
        this._ltr_min = this.minusArray;
        this._ltr_plus = this.plusArray;
        this.lineArray = new Array("line2_rtl.gif", "line3_rtl.gif", "line4_rtl.gif", "blank.gif", "blank.gif", "line1_rtl.gif");
        this.minusArray = new Array("minus2_rtl.gif", "minus3_rtl.gif", "minus4_rtl.gif", "minus.gif", "minus5_rtl.gif");
        this.plusArray = new Array("plus2_rtl.gif", "plus3_rtl.gif", "plus4_rtl.gif", "plus.gif", "plus5_rtl.gif");
        this.allTree.className = "containerTableStyleRTL";
    }
    else {
        this.allTree.className = "containerTableStyle";
        this.lineArray = this._ltr_line;
        this.minusArray = this._ltr_min;
        this.plusArray = this._ltr_plus;
    }
    if (this.htmlNode.childsCount) {
        this._redrawFrom(this, this.htmlNode);
    }
};
dhtmlXTreeObject.prototype.sortTree = function (g, c, e) {
    var a = this._globalIdStorageFind(g);
    if (!a) {
        return false;
    }
    this._reorderBranch(a, c.toString().toLowerCase() == "asc", dhx4.s2b(e));
};
dhtmlXTreeObject.prototype.setCustomSortFunction = function (a) {
    this._csfunca = a;
};
dhtmlXTreeObject.prototype._reorderBranch = function (n, c, o) {
    var a = [];
    var l = n.childsCount;
    if (!l) {
        return;
    }
    var h = n.childNodes[0].tr.parentNode;
    for (var g = 0; g < l; g++) {
        a[g] = n.childNodes[g];
        h.removeChild(a[g].tr);
    }
    var e = this;
    if (c == 1) {
        if (this._csfunca) {
            a.sort(function (r, m) {
                return e._csfunca(r.id, m.id);
            });
        }
        else {
            a.sort(function (r, m) {
                return r.span.innerHTML.toUpperCase() > m.span.innerHTML.toUpperCase()
                    ? 1
                    : r.span.innerHTML.toUpperCase() == m.span.innerHTML.toUpperCase()
                        ? 0
                        : -1;
            });
        }
    }
    else {
        if (this._csfunca) {
            a.sort(function (r, m) {
                return e._csfunca(m.id, r.id);
            });
        }
        else {
            a.sort(function (r, m) {
                return r.span.innerHTML.toUpperCase() < m.span.innerHTML.toUpperCase()
                    ? 1
                    : r.span.innerHTML.toUpperCase() == m.span.innerHTML.toUpperCase()
                        ? 0
                        : -1;
            });
        }
    }
    for (var g_1 = 0; g_1 < l; g_1++) {
        h.appendChild(a[g_1].tr);
        n.childNodes[g_1] = a[g_1];
        if (o && a[g_1].unParsed) {
            a[g_1].unParsed.set("order", c ? 1 : -1);
        }
        else {
            if (o && a[g_1].childsCount) {
                this._reorderBranch(a[g_1], c, o);
            }
        }
    }
    for (var g_2 = 0; g_2 < l; g_2++) {
        this._correctPlus(a[g_2]);
        this._correctLine(a[g_2]);
    }
};
dhtmlXTreeObject.prototype._reorderXMLBranch = function (l) {
    var n = l.getAttribute("order");
    if (n == "none") {
        return;
    }
    var c = n == 1;
    var h = l.childNodes.length;
    if (!h) {
        return;
    }
    var a = new Array();
    var e = 0;
    for (var g = 0; g < h; g++) {
        if (l.childNodes[g].nodeType == 1) {
            a[e] = l.childNodes[g];
            e++;
        }
    }
    for (var g_3 = h - 1; g_3 != 0; g_3--) {
        l.removeChild(l.childNodes[g_3]);
    }
    if (c) {
        a.sort(function (o, m) {
            return o.getAttribute("text") > m.getAttribute("text")
                ? 1
                : o.getAttribute("text") == m.getAttribute("text")
                    ? 0
                    : -1;
        });
    }
    else {
        a.sort(function (o, m) {
            return o.getAttribute("text") < m.getAttribute("text")
                ? 1
                : o.getAttribute("text") == m.getAttribute("text")
                    ? 0
                    : -1;
        });
    }
    for (var g_4 = 0; g_4 < e; g_4++) {
        a[g_4].setAttribute("order", n);
        l.appendChild(a[g_4]);
    }
    l.setAttribute("order", "none");
};
dhtmlXTreeObject.prototype._serEnts = [
    ["&", "&amp;"],
    ["<", "&lt;"],
    [">", "&gt;"]
];
dhtmlXTreeObject.prototype.registerXMLEntity = function (a, c) {
    this._serEnts[this._serEnts.length] = [a, c, new RegExp(a, "g")];
};
dhtmlXTreeObject.prototype.setSerializationLevel = function (a, c, h, l, e) {
    this._xuserData = dhx4.s2b(a);
    this._xfullXML = dhx4.s2b(c);
    this._dtd = e;
    this._xescapeEntities = dhx4.s2b(h);
    if (dhx4.s2b(l)) {
        this._apreUC = "<![CDATA[";
        this._apstUC = "]]>";
    }
    for (var g = 0; g < this._serEnts.length; g++) {
        this._serEnts[g][2] = new RegExp(this._serEnts[g][0], "g");
    }
};
dhtmlXTreeObject.prototype.serializeTree = function () {
    if (this.stopEdit) {
        this.stopEdit();
    }
    this._apreUC = this._apreUC || "";
    this._apstUC = this._apstUC || "";
    var a = '<?xml version="1.0"?>';
    if (this._dtd) {
        a += '<!DOCTYPE tree SYSTEM "' + this._dtd + '">';
    }
    a += '<tree id="' + this.rootId + '">';
    if (this._xuserData && this._idpull[this.rootId]._userdatalist) {
        var e = this._idpull[this.rootId]._userdatalist.split(",");
        for (var c = 0; c < e.length; c++) {
            a +=
                '<userdata name="' +
                    e[c] +
                    '">' +
                    this._apreUC +
                    this._idpull[this.rootId].userData["t_" + e[c]] +
                    this._apstUC +
                    "</userdata>";
        }
    }
    for (var c_2 = 0; c_2 < this.htmlNode.childsCount; c_2++) {
        a += this._serializeItem(this.htmlNode.childNodes[c_2]);
    }
    a += "</tree>";
    return a;
};
dhtmlXTreeObject.prototype._serializeItem = function (m) {
    if (m.unParsed) {
        if (dhx4.isIE) {
            return m.unParsed.d.xml;
        }
        else {
            var a = new XMLSerializer();
            return a.serializeToString(m.unParsed.d);
        }
    }
    var c = "";
    if (this._selected.length) {
        var g = this._selected[0].id;
    }
    else {
        g = '"';
    }
    var l = m.span.innerHTML;
    if (this._xescapeEntities) {
        for (var e = 0; e < this._serEnts.length; e++) {
            l = l.replace(this._serEnts[e][2], this._serEnts[e][1]);
        }
    }
    if (!this._xfullXML) {
        c =
            '<item id="' +
                m.id +
                '" ' +
                (this._getOpenState(m) == 1 ? ' open="1" ' : "") +
                (g == m.id ? ' select="1"' : "") +
                ' text="' +
                l +
                '"' +
                (this.XMLsource && m.XMLload == 0 ? ' child="1" ' : "") +
                ">";
    }
    else {
        c =
            '<item id="' +
                m.id +
                '" ' +
                (this._getOpenState(m) == 1 ? ' open="1" ' : "") +
                (g == m.id ? ' select="1"' : "") +
                ' text="' +
                l +
                '" im0="' +
                m.images[0] +
                '" im1="' +
                m.images[1] +
                '" im2="' +
                m.images[2] +
                '" ' +
                (m.acolor ? 'aCol="' + m.acolor + '" ' : "") +
                (m.scolor ? 'sCol="' + m.scolor + '" ' : "") +
                (m.checkstate == 1
                    ? 'checked="1" '
                    : m.checkstate == 2
                        ? 'checked="-1"'
                        : "") +
                (m.closeable ? 'closeable="1" ' : "") +
                (this.XMLsource && m.XMLload == 0 ? ' child="1" ' : "") +
                ">";
    }
    if (this._xuserData && m._userdatalist) {
        var h = m._userdatalist.split(",");
        for (var e_1 = 0; e_1 < h.length; e_1++) {
            c +=
                '<userdata name="' +
                    h[e_1] +
                    '">' +
                    this._apreUC +
                    m.userData["t_" + h[e_1]] +
                    this._apstUC +
                    "</userdata>";
        }
    }
    for (var e_2 = 0; e_2 < m.childsCount; e_2++) {
        c += this._serializeItem(m.childNodes[e_2]);
    }
    c += "</item>";
    return c;
};
dhtmlXTreeObject.prototype.saveSelectedItem = function (c, a) {
    c = c || "";
    this.setCookie("treeStateSelected" + c, this.getSelectedItemId(), a);
};
dhtmlXTreeObject.prototype.restoreSelectedItem = function (a) {
    a = a || "";
    var c = this.getCookie("treeStateSelected" + a);
    this.selectItem(c, false);
};
dhtmlXTreeObject.prototype.enableAutoSavingSelected = function (a, c) {
    this.assMode = dhx4.s2b(a);
    if (this.assMode && !this.oldOnSelect) {
        this.oldOnSelect = this.onRowSelect;
        this.onRowSelect = function (h, g, l) {
            if (!g) {
                g = this;
            }
            g.parentObject.treeNod.oldOnSelect(h, g, l);
            if (g.parentObject.treeNod.assMode) {
                g.parentObject.treeNod.saveSelectedItem(g.parentObject.treeNod.assCookieName);
            }
        };
    }
    this.assCookieName = c;
};
dhtmlXTreeObject.prototype.saveState = function (e, c) {
    var h = this._escape(this.serializeTree());
    var a = 4000;
    if (h.length > a) {
        if (navigator.appName.indexOf("Microsoft") != -1) {
            return false;
        }
        this.setCookie("treeStatex" + e, Math.ceil(h.length / a));
        for (var g = 0; g < Math.ceil(h.length / a); g++) {
            this.setCookie("treeStatex" + e + "x" + g, h.substr(g * a, a), c);
        }
    }
    else {
        this.setCookie("treeStatex" + e, h, c);
    }
    h = this.getCookie("treeStatex" + e);
    if (!h) {
        this.setCookie("treeStatex" + e, "", c);
        return false;
    }
    return true;
};
dhtmlXTreeObject.prototype.loadState = function (a) {
    var g = this.getCookie("treeStatex" + a);
    if (!g) {
        return false;
    }
    if (g.length) {
        if (g.toString().length < 4) {
            var e = "";
            for (var c = 0; c < g; c++) {
                e += this.getCookie("treeStatex" + a + "x" + c);
            }
            g = e;
        }
        this.parse(this.utfesc == "utf8" ? decodeURI(g) : unescape(g));
    }
    return true;
};
dhtmlXTreeObject.prototype.setCookie = function (c, e, a) {
    var g = c + "=" + e + (a ? "; " + a : "");
    document.cookie = g;
};
dhtmlXTreeObject.prototype.getCookie = function (c) {
    var e = c + "=";
    if (document.cookie.length > 0) {
        var g = document.cookie.indexOf(e);
        if (g != -1) {
            g += e.length;
            var a = document.cookie.indexOf(";", g);
            if (a == -1) {
                a = document.cookie.length;
            }
            return document.cookie.substring(g, a);
        }
    }
};
dhtmlXTreeObject.prototype.saveOpenStates = function (c, a) {
    var g = [];
    for (var e = 0; e < this.htmlNode.childsCount; e++) {
        g = g.concat(this._collectOpenStates(this.htmlNode.childNodes[e]));
    }
    g = g.join(this.dlmtr);
    this.setCookie("treeOpenStatex" + c, g, a);
};
dhtmlXTreeObject.prototype.loadOpenStates = function (c) {
    for (var e = 0; e < this.htmlNode.childsCount; e++) {
        this._xcloseAll(this.htmlNode.childNodes[e]);
    }
    this.allTree.childNodes[0].border = "1";
    this.allTree.childNodes[0].border = "0";
    var h = getCookie("treeOpenStatex" + c);
    if (h) {
        var a = h.split(this.dlmtr);
        for (var e_3 = 0; e_3 < a.length; e_3++) {
            var g = this._globalIdStorageFind(a[e_3]);
            if (g) {
                if (this.XMLsource && !g.XMLload && g.id != this.rootId) {
                    this._delayedLoad(g, "loadOpenStates('" + c + "')");
                    return;
                }
                else {
                    this.openItem(a[e_3]);
                }
            }
        }
    }
    this.callEvent("onAllOpenDynamic", []);
};
dhtmlXTreeObject.prototype._delayedLoad = function (c, a) {
    this.afterLoadMethod = a;
    this.onLoadReserve = this.onXLE;
    this.onXLE = this._delayedLoadStep2;
    this._loadDynXML(c.id);
};
dhtmlXTreeObject.prototype._delayedLoadStep2 = function (tree) {
    tree.onXLE = tree.onLoadReserve;
    window.setTimeout(function () {
        dhtmlx.temp = tree;
        eval("dhtmlx.temp." + tree.afterLoadMethod);
    }, 100);
    if (tree.onXLE) {
        tree.onXLE(tree);
    }
    tree.callEvent("onXLE", [tree]);
};
dhtmlXTreeObject.prototype._collectOpenStates = function (c) {
    var e = [];
    if (this._getOpenState(c) == 1) {
        e.push(c.id);
        for (var a = 0; a < c.childsCount; a++) {
            e = e.concat(this._collectOpenStates(c.childNodes[a]));
        }
    }
    return e;
};
dhtmlXTreeObject.prototype.openAllItemsDynamic = function (a) {
    this.ClosedElem = new Array();
    this.G_node = null;
    var c = this._globalIdStorageFind(a || this.rootId);
    if (c.id != this.rootId && this.getOpenState(c.id) != 0) {
        this.openItem(a);
    }
    this._openAllNodeChilds(c, 0);
    if (this.ClosedElem.length > 0) {
        this.onLoadReserve = this.onXLE;
        this.onXLE = this._loadAndOpen;
        this._loadAndOpen(this);
    }
};
dhtmlXTreeObject.prototype._openAllNodeChilds = function (c) {
    if (c.XMLload == 0 || c.unParsed) {
        this.ClosedElem.push(c);
    }
    for (var a = 0; a < c.childsCount; a++) {
        if (this._getOpenState(c.childNodes[a]) < 0) {
            this._HideShow(c.childNodes[a], 2);
        }
        if (c.childNodes[a].childsCount > 0) {
            this._openAllNodeChilds(c.childNodes[a]);
        }
        if (c.childNodes[a].XMLload == 0 || c.childNodes[a].unParsed) {
            this.ClosedElem.push(c.childNodes[a]);
        }
    }
};
dhtmlXTreeObject.prototype._loadAndOpen = function (a) {
    if (a.G_node) {
        a._openItem(a.G_node);
        a._openAllNodeChilds(a.G_node);
        a.G_node = null;
    }
    if (a.ClosedElem.length > 0) {
        a.G_node = a.ClosedElem.shift();
    }
    if (a.G_node) {
        if (a.G_node.unParsed) {
            a.reParse(a.G_node);
        }
        else {
            window.setTimeout(function () {
                a._loadDynXML(a.G_node.id);
            }, 100);
        }
    }
    else {
        a.onXLE = a.onLoadReserve;
        if (a.onXLE) {
            a.onXLE(a);
        }
        a.callEvent("onAllOpenDynamic", [a]);
    }
};
dhtmlXTreeObject.prototype.openItemsDynamic = function (c, a) {
    if (this.onXLE == this._stepOpen) {
        return;
    }
    this._opnItmsDnmcFlg = dhx4.s2b(a);
    this.onLoadReserve = this.onXLE;
    this.onXLE = this._stepOpen;
    this.ClosedElem = c.split(",").reverse();
    this._stepOpen(this);
};
dhtmlXTreeObject.prototype._stepOpen = function (c) {
    if (!c.ClosedElem.length) {
        c.onXLE = c.onLoadReserve;
        if (c._opnItmsDnmcFlg) {
            c.selectItem(c.G_node, true);
        }
        if (c.onXLE && arguments[1]) {
            c.onXLE.apply(c, arguments);
        }
        c.callEvent("onOpenDynamicEnd", []);
        return;
    }
    c.G_node = c.ClosedElem.pop();
    c.skipLock = true;
    var a = c._globalIdStorageFind(c.G_node);
    if (a) {
        if (a.XMLload === 0) {
            c.openItem(c.G_node);
        }
        else {
            c.openItem(c.G_node);
            c._stepOpen(c);
        }
    }
    c.skipLock = false;
};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXTreeObject/dxTreeObjectMethods2.js